import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import meetingApi from '@/services/meeting';
import MeetingDetail from '@/components/meeting/MeetingDetail.vue';
export default {
  name: 'MyApproval',
  components: {
    MeetingDetail: MeetingDetail
  },
  data: function data() {
    var _this = this;
    return {
      searchForm: {
        type: '0',
        meetingName: '',
        roomId: ''
      },
      roomList: [],
      approvalList: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        onShowSizeChange: function onShowSizeChange(current, pageSize) {
          _this.pagination.pageSize = pageSize;
          _this.search();
        },
        onChange: function onChange(current) {
          _this.pagination.current = current;
          _this.search();
        }
      },
      detailVisible: false,
      selectedId: null,
      approvalDone: false
    };
  },
  created: function created() {
    this.loadRooms();
    this.search();
  },
  methods: {
    loadRooms: function loadRooms() {
      var _this2 = this;
      meetingApi.queryRoomList().then(function (res) {
        if (res.data && res.data.code === 200) {
          _this2.roomList = res.data.data || [];
        }
      });
    },
    onTypeChange: function onTypeChange() {
      this.pagination.current = 1;
      this.search();
    },
    search: function search() {
      var _this3 = this;
      this.loading = true;
      var params = {
        type: this.searchForm.type,
        meetingName: this.searchForm.meetingName,
        roomId: this.searchForm.roomId,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      meetingApi.queryMyFinishedAndToDoList(params).then(function (res) {
        if (res.data && res.data.code === 200) {
          _this3.approvalList = res.data.rows || [];
          _this3.pagination.total = res.data.total || 0;
        } else {
          _this3.approvalList = [];
          _this3.pagination.total = 0;
          _this3.$message.error(res.data.message || '获取数据失败');
        }
      }).catch(function (err) {
        _this3.approvalList = [];
        _this3.pagination.total = 0;
        _this3.$message.error('获取数据失败');
      }).finally(function () {
        _this3.loading = false;
      });
    },
    reset: function reset() {
      this.searchForm = {
        type: '0',
        meetingName: '',
        roomId: ''
      };
      this.pagination.current = 1;
      this.search();
    },
    viewDetail: function viewDetail(record) {
      this.selectedId = record.id;
      this.approvalDone = false;
      this.detailVisible = true;
    },
    onApprovalSuccess: function onApprovalSuccess() {
      this.approvalDone = true;
    },
    handleModalClose: function handleModalClose() {
      if (this.approvalDone) {
        this.search();
      }
      this.detailVisible = false;
    },
    getStatusText: function getStatusText(status) {
      var statusMap = {
        'DRAFT': '草稿',
        'PENDING_APPROVAL': '待审批',
        'APPROVED': '审批中',
        'REJECTED': '已拒绝',
        'END': '已通过',
        'CANCELLED': '已取消'
      };
      return statusMap[status] || status;
    },
    getStatusColor: function getStatusColor(status) {
      var colorMap = {
        'DRAFT': 'cyan',
        'PENDING_APPROVAL': 'orange',
        'APPROVED': 'green',
        'END': 'purple',
        'REJECTED': 'red',
        'CANCELLED': 'gray'
      };
      return colorMap[status] || 'default';
    }
  },
  computed: {
    columns: function columns() {
      return [{
        title: '流水号',
        dataIndex: 'id',
        key: 'id',
        width: 100
      }, {
        title: '会议标题',
        dataIndex: 'meetingName',
        key: 'meetingName',
        ellipsis: true
      }, {
        title: '会议室',
        dataIndex: 'room',
        key: 'room',
        width: 120
      }, {
        title: '申请人',
        dataIndex: 'applicantName',
        key: 'applicantName',
        width: 100
      }, {
        title: '申请部门',
        dataIndex: 'department',
        key: 'department',
        width: 120
      }, {
        title: '预约日期',
        dataIndex: 'reservationDate',
        key: 'reservationDate',
        width: 120
      }, {
        title: '办理状态',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        title: '操作',
        key: 'action',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }];
    }
  }
};